import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getFeeSettings() {
  const response = await axiosClient.get("/admin/fees/settings");
  return response.data;
}

export async function getFeeSettingsHistory() {
  const response = await axiosClient.get("/admin/fees/settings/history");
  return response.data;
}

export async function updateFeeSettings(payload) {
  const response = await axiosClient.put("/admin/fees/settings", payload);
  return response.data;
}

export async function getStoreSubscriptions(params) {
  const response = await axiosClient.get(`/admin/fees/store-subscriptions${toQueryString(params)}`);
  return response.data;
}

export async function getStoreSubscriptionDetail(storeId) {
  const response = await axiosClient.get(`/admin/fees/store-subscriptions/${storeId}`);
  return response.data;
}

export async function overrideStoreSubscriptionStatus(storeId, status, note) {
  const response = await axiosClient.put(`/admin/fees/store-subscriptions/${storeId}/override`, { status, note });
  return response.data;
}

export async function clearStoreSubscriptionOverride(storeId) {
  const response = await axiosClient.put(`/admin/fees/store-subscriptions/${storeId}/clear-override`);
  return response.data;
}

export async function markInvoicePaid(storeId, invoiceId, note) {
  const response = await axiosClient.put(
    `/admin/fees/store-subscriptions/${storeId}/invoices/${invoiceId}/mark-paid`,
    { note }
  );
  return response.data;
}

export async function renewStoreSubscription(storeId, payload) {
  const response = await axiosClient.post(`/admin/fees/store-subscriptions/${storeId}/renew`, payload);
  return response.data;
}

export async function setSubscriptionPriceOverride(storeId, subscriptionPriceOverride) {
  const response = await axiosClient.put(`/admin/fees/store-subscriptions/${storeId}/price-override`, {
    subscriptionPriceOverride,
  });
  return response.data;
}

export async function getSettlements(params) {
  const response = await axiosClient.get(`/admin/fees/settlements${toQueryString(params)}`);
  return response.data;
}

export async function getSettlementDetail(id) {
  const response = await axiosClient.get(`/admin/fees/settlements/${id}`);
  return response.data;
}

export async function generateSettlement(payload) {
  const response = await axiosClient.post("/admin/fees/settlements/generate", payload);
  return response.data;
}

export async function markSettlementPaid(id, note) {
  const response = await axiosClient.put(`/admin/fees/settlements/${id}/mark-paid`, { note });
  return response.data;
}

export async function getStoreRevenue(params) {
  const response = await axiosClient.get(`/admin/fees/store-revenue${toQueryString(params)}`);
  return response.data;
}

export async function collectStoreFees(storeId, note) {
  const response = await axiosClient.post(`/admin/fees/store-revenue/${storeId}/collect`, { note });
  return response.data;
}

export async function collectStoreFeesBulk(storeIds, note) {
  const response = await axiosClient.post(`/admin/fees/store-revenue/collect-bulk`, { storeIds, note });
  return response.data;
}

export async function undoStoreFeesCollection(settlementId) {
  const response = await axiosClient.post(`/admin/fees/store-revenue/collections/${settlementId}/undo`);
  return response.data;
}

export async function getStorePendingFees(storeId) {
  const response = await axiosClient.get(`/admin/fees/store-revenue/${storeId}/pending`);
  return response.data;
}

export async function getStoreRevenueHistory(params) {
  const response = await axiosClient.get(`/admin/fees/store-revenue/history${toQueryString(params)}`);
  return response.data;
}

export async function getDeliveryRevenue(params) {
  const response = await axiosClient.get(`/admin/fees/delivery-revenue${toQueryString(params)}`);
  return response.data;
}

export async function requestDeliveryFees(companyUserId, note) {
  const response = await axiosClient.post(`/admin/fees/delivery-revenue/${companyUserId}/request`, { note });
  return response.data;
}

export async function undoDeliveryFeesRequest(settlementId) {
  const response = await axiosClient.post(`/admin/fees/delivery-revenue/settlements/${settlementId}/undo`);
  return response.data;
}

export async function getCompanyStoreBreakdown(companyUserId) {
  const response = await axiosClient.get(`/admin/fees/delivery-revenue/${companyUserId}/stores`);
  return response.data;
}
